import { Backdrop, CircularProgress } from '@mui/material';

export const Spinner = () => {
    return (
        <Backdrop sx={{ color: '#fff', zIndex: (theme: { zIndex: { drawer: number } }) => theme.zIndex.drawer + 1 }} open={true}>
            <CircularProgress color="inherit" />
        </Backdrop>
    );
};
